/* Dbeauty motion v2.1: reveal-on-scroll, hero entrance, scent selector focus,
   ribbon marquee (only when it overflows), pointer-tracked glass highlight and
   the drawer-aware add-to-cart used by the ritual sections. Plain ES module. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Reveal on scroll ------------------------------------------------- */
  const revealEls = Array.from(document.querySelectorAll('[data-ds-reveal]'));
  if (!reduce && 'IntersectionObserver' in window) {
    revealEls.forEach((el) => { if (el.getAttribute('data-ds-reveal') === '') el.setAttribute('data-ds-reveal', 'pending'); });
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) if (e.isIntersecting) { e.target.setAttribute('data-ds-reveal', 'in'); io.unobserve(e.target); }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.setAttribute('data-ds-reveal', 'in'));
  }
  document.querySelectorAll('[data-ds-stagger]').forEach((group) => {
    Array.from(group.children).forEach((child, i) => child.style.setProperty('--i', String(i)));
  });

  /* 2. Hero entrance. This module is deferred, so the DOM is parsed by now:
        start on the next frame rather than waiting for window.load, which
        would hold the headline back behind every script on the page. -------- */
  const heroes = document.querySelectorAll('.dsh');
  const startHero = () => heroes.forEach((h) => h.classList.add('is-in'));
  requestAnimationFrame(() => requestAnimationFrame(startHero));
  setTimeout(startHero, 600);

  /* 3. Scent selector: the side you hover breathes wider ----------------- */
  document.querySelectorAll('.dss').forEach((sel) => {
    sel.querySelectorAll('.dss__panel').forEach((panel) => {
      const on = () => sel.setAttribute('data-active', panel.dataset.scent || '');
      panel.addEventListener('pointerenter', on);
      panel.addEventListener('focusin', on);
    });
    sel.addEventListener('pointerleave', () => sel.removeAttribute('data-active'));
  });

  /* 4. Ribbon: marquee only when the line does not fit ------------------- */
  const fitRibbon = (r) => {
    const list = r.querySelector('.dsr__list');
    if (!list) return;
    r.classList.remove('dsr--marquee');
    if (list.scrollWidth > r.clientWidth + 4) r.classList.add('dsr--marquee');
  };
  document.querySelectorAll('.dsr').forEach((r) => {
    fitRibbon(r);
    if ('ResizeObserver' in window) new ResizeObserver(() => fitRibbon(r)).observe(r);
  });

  /* 5. Glass buttons: the highlight follows the pointer ------------------ */
  if (!reduce && window.matchMedia('(hover: hover)').matches) {
    let frame = 0;
    document.addEventListener('pointermove', (e) => {
      const b = e.target instanceof Element ? e.target.closest('.dsb') : null;
      if (!b || frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const r = b.getBoundingClientRect();
        b.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        b.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    }, { passive: true });
    document.addEventListener('pointerout', (e) => {
      const b = e.target instanceof Element ? e.target.closest('.dsb') : null;
      if (b && !(e.relatedTarget instanceof Element && b.contains(e.relatedTarget))) { b.style.removeProperty('--mx'); b.style.removeProperty('--my'); }
    }, { passive: true });
  }

  /* 6. Add to cart from the ritual sections and the drawer --------------- */
  const drawerSectionId = () => document.querySelector('cart-items-component[data-section-id]')?.getAttribute('data-section-id') || null;
  document.addEventListener('submit', async (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target.closest('form[data-ds-add]') : null;
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"], [type="submit"]');
    const fd = new FormData(form);
    const id = fd.get('id');
    const quantity = Number(fd.get('quantity') || 1);
    if (!id) return;
    button?.setAttribute('aria-busy', 'true');
    form.classList.remove('has-error');
    try {
      const sectionId = drawerSectionId();
      const body = { items: [{ id, quantity }] };
      if (sectionId) body.sections = sectionId;
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const added = await res.json();
      if (!res.ok) throw added;
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const evt = new Event('cart:update', { bubbles: true });
      evt.detail = { resource: cart, sourceId: form.id || 'dbeauty-add', data: { source: 'dbeauty-add', itemCount: cart.item_count, variantId: String(id), sections: added.sections || {} } };
      document.dispatchEvent(evt);
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
      if (button) {
        const label = button.getAttribute('data-label') || button.textContent;
        const addedLabel = button.getAttribute('data-added') || 'Added';
        button.classList.add('is-added');
        button.textContent = addedLabel;
        setTimeout(() => { button.classList.remove('is-added'); button.textContent = label; }, 1400);
      }
    } catch (err) {
      console.warn('[dbeauty] add to cart failed', err);
      form.classList.add('has-error');
    } finally {
      button?.removeAttribute('aria-busy');
    }
  });
})();
